<template>
  <div class="modal fade" tabindex="-1" role="dialog" v-on:keyup.enter="link">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <div class="modal-header">
          <h4 class="modal-title">Link this testimony to the following case(s) : </h4>
        </div>
        <div class="modal-body col-lg-6">
            <multiselect
                v-model="selected" 
                :options="cases"
                :multiple="true"
                track-by="_id"
                :custom-label="customLabel">
            </multiselect>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
          <button v-on:click="link" type="button" class="btn btn-danger" data-dismiss="modal">Confirm</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import api from '../../api'
  import moment from 'moment'

  export default {
    props: ['preselected'],
    name: 'LinkCaseModal',
    components: { Multiselect },
    data () {
      return {
        selected: null,
        cases: []
      }
    },
    methods: {
      link () {
        window.jQuery('#LinkCaseModal').modal('hide')
        this.$emit('link', this.selected)
        this.selected = []
      },
      removeLinkedCases () {
        this.cases = this.cases.filter((c) => {
          return !this.preselected.some((p) => {
            return p._id === c._id
          })
        })
        console.log(this.cases)
      },
      customLabel (option) {
        return `${moment(option.creationDate).format('DD/MM/YYYY')} - ${option.name}`
      },
      getCases () {
        api.authenticatedRequest('get', `/cases?size=100`)
        .then(response => {
          this.cases = response.data.data
          return this.cases
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getCases()
      })
    }
  }

</script>

<style>
.modal-dialog, .modal-content {
    width: 100% !important;
    height: 100% !important;
}
.modal-dialog {
    margin: 0 !important;
}
.modal-content {
    background: rgba(255, 255, 255, .92);
    align-content: center;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}
.modal.fade.in {
    display: flex !important;
}

.modal.in .modal-dialog, .modal.fade .modal-dialog {
    transform: none;
    opacity: 1;
    transition: opacity .3s ease;
}

.modal .close {
    width: 2rem;
    height: 3rem;
    cursor: pointer;
    fill: #555;
    position: absolute;
    right: 4rem;
    top: 3rem;
    transition: fill .2s;
    display: block;
    font-size: 30px;
    outline: none;
}

.modal-footer button:active:focus {
    outline: none;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// LinkCaseModal.vue?1947ae06